import ScheduleScrollType from "@/constants/ScheduleScrollType";

export default {
	[ ScheduleScrollType.TODAY ]: {
		targetSelector: () => ".schedule-day--today",
		toPosition: scrollTarget => scrollTarget.offsetTop - 25, // eslint-disable-line no-magic-numbers
		duration: 500,
	},
	[ ScheduleScrollType.SELECTED_DATE ]: {
		targetSelector: selectedDate => `.schedule-day--${selectedDate.format( "YYYY-MM-DD" )}`,
		toPosition: scrollTarget => scrollTarget.offsetTop - 25, // eslint-disable-line no-magic-numbers
		duration: 500,
	},
	[ ScheduleScrollType.WEEK_CHANGE ]: {
		targetSelector: () => "#schedulePlannerRow",
		toPosition: () => 0, // eslint-disable-line no-magic-numbers
		duration: 0,
	},
	[ ScheduleScrollType.SELECTED_MEETING ]: {
		targetSelector: () => ".schedule-meeting--selected",
		toPosition: scrollTarget => scrollTarget.offsetTop - 25, // eslint-disable-line no-magic-numbers
		duration: 500,
	},
};



// WEBPACK FOOTER //
// ./src/helpers/scrollDefinitions.js